import React from "react";
import { Skeleton, Stack } from "@mui/material";
import { Card, CardTitle, CardRow, EmptyState } from "./styles";

interface DriverCardProps {
  title?: React.ReactNode;
  children: React.ReactNode;
}

interface DriverListSkeletonProps {
  cards?: number;
  rows?: number;
}

export function DriverCard({ title, children }: DriverCardProps) {
  return (
    <Card>
      {title && <CardTitle>{title}</CardTitle>}
      {children}
    </Card>
  );
}

export function DriverListSkeleton({ cards = 3, rows = 3 }: DriverListSkeletonProps) {
  return (
    <Stack spacing={1.5} aria-label="Carregando dados" role="status">
      {Array.from({ length: cards }, (_, cardIndex) => (
        <Card key={cardIndex} aria-hidden="true">
          <Skeleton variant="text" width="28%" height={26} sx={{ mb: 1 }} />
          <Stack spacing={0.75}>
            {Array.from({ length: rows }, (_, rowIndex) => (
              <Skeleton
                key={rowIndex}
                variant="text"
                width={rowIndex === rows - 1 ? "56%" : "100%"}
                height={20}
              />
            ))}
          </Stack>
        </Card>
      ))}
    </Stack>
  );
}

export { CardRow, EmptyState };
export default DriverCard;